<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("PRODUCTS.ADD_PRODUCT") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <product-form
              :loading="loading"
              :productData="product"
              :formErrors="formErrors"
              @productSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultProduct from "./defaultProduct";
import ProductForm from "./partials/ProductForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ProductForm,
  },

  mixins: [alertLeave],

  data() {
    const product = cloneDeep(defaultProduct);
    const me = this.$store.getters["profile/me"];
    return {
      product: product,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List Products" });
    },

    viewProduct(product) {
      this.alertLeave = false;
      this.$router.push({
        name: "View Product",
        params: { id: product.id },
      });
    },

    async handleSubmit(product) {
      this.loading = true;
      const me = this.$store.getters["profile/me"];

      const productData = cloneDeep(product);
      delete productData.id;

      try {
        await this.$store.dispatch("products/add", productData);
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.PRODUCT_ADDED"),
        });
        const product = await this.$store.getters["products/product"];
        this.viewProduct(product);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
